module.exports = __webpack_public_path__ + "static/chrisliebing_3-bee406b95c18131cf414f7d58b25293d.jpg";